import { Heart, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function AlphaBanner({ onContactClick, onClose }: { onContactClick?: () => void, onClose?: () => void }) {
    const { t } = useTranslation(['landing']);
    const [isVisible, setIsVisible] = useState(true);

    // Auto-hide after 8 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            if (onClose) onClose();
        }, 8000);

        return () => clearTimeout(timer);
    }, [onClose]);

    if (!isVisible) return null;

    return (
        <div className="bg-blue-600 text-white px-4 sm:px-6 py-2 sm:py-3 relative z-[100] shadow-xl animate-in slide-in-from-top duration-500">
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-3 sm:gap-4">
                <div className="flex items-center gap-3 sm:gap-4 flex-1 min-w-0">
                    <div className="p-1.5 bg-white/20 rounded-lg hidden md:block shrink-0">
                        <Heart size={20} className="text-white fill-current animate-pulse" />
                    </div>
                    <div className="min-w-0">
                        <div className="flex items-center gap-2 mb-0.5 sm:mb-1">
                            <span className="bg-yellow-400 text-blue-900 text-[8px] sm:text-[10px] font-black px-1.5 py-0.5 rounded-md uppercase tracking-widest shrink-0">
                                {t('alpha_banner.title')}
                            </span>
                            <p className="text-[10px] sm:text-sm font-medium leading-tight opacity-95 truncate sm:whitespace-normal">
                                {t('alpha_banner.message')}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex items-center gap-2 sm:gap-3 shrink-0">
                    <button
                        onClick={onContactClick}
                        className="whitespace-nowrap bg-white text-blue-600 hover:bg-blue-50 px-3 sm:px-5 py-1.5 sm:py-2 rounded-lg sm:rounded-xl text-[10px] sm:text-sm font-black transition shadow-sm active:scale-95"
                    >
                        {t('alpha_banner.cta')}
                    </button>
                    <button
                        onClick={() => {
                            setIsVisible(false);
                            if (onClose) onClose();
                        }}
                        className="p-1.5 sm:p-2 hover:bg-white/20 rounded-full transition shrink-0"
                        aria-label="Close"
                    >
                        <X size={20} className="w-4 h-4 sm:w-5 sm:h-5" />
                    </button>
                </div>
            </div>
        </div>
    );
}
